import { usePostHog } from 'posthog-js/react';
import { FC, Fragment } from 'react';

import { useCartContext } from '../../../hooks/contexts/cart.context';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { HolderProps } from '../../../types/cart';
import { TicketDate } from '../../../types/ticket';
import * as Styles from './holder-ticket-checkbox.styles';

type HolderTicketCheckboxProps = {
  handleChecked: () => void;
  holder: HolderProps | null;
  isAKidsTicket: boolean;
  id: string;
  sessions: TicketDate[];
  isBepass: boolean;
}

const HolderTicketCheckbox: FC<HolderTicketCheckboxProps> = ({
  handleChecked,
  holder,
  isAKidsTicket,
  id,
  sessions,
  isBepass,
}) => {
  const posthog = usePostHog();
  const { translate } = useI18nContext();
  const { blockedSessionsForMe } = useCartContext();

  const disabledCheckbox = sessions.some((session) => blockedSessionsForMe.includes(session.id)) && isBepass;

  return (
    <Fragment>
      {(!holder && !isAKidsTicket) && (
        <Styles.ContainerCheckBox id={`checkbox-container-${id}`}>
          <Styles.CheckBox
            onChange={() => {
              handleChecked();
              posthog?.capture('purchase:transfer_myticket_selection');
            }}
            type="checkbox"
            id={`checkbox-${id}`}
            checked={false}
            disabled={disabledCheckbox}
          />
          <Styles.TextInfoBold
            id={`checkbox-text-bold-${id}`}
            $disabledText={disabledCheckbox}
          >
            {translate(['INFORMATION', 'MY_TICKET'])}
          </Styles.TextInfoBold>
        </Styles.ContainerCheckBox>
      )}
    </Fragment>
  );
};

export default HolderTicketCheckbox;
